/*
 * CongregationEdit Messages
 *
 * This contains all the text for the CongregationEdit component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  deleteButton: {
    id: 'app.components.CongregationDeleteButton.deleteButton',
    defaultMessage: 'Delete',
  },
  deleteSuccess: {
    id: 'app.components.CongregationDeleteButton.deleteSuccess',
    defaultMessage: 'Congregation has been successfully deleted.',
  },
  deleteFailure: {
    id: 'app.components.CongregationDeleteButton.deleteFailure',
    defaultMessage: 'Error. The congregation could not be deleted.',
  },
  deleteConfirmTitle: {
    id: 'app.components.CongregationDeleteButton.deleteConfirmTitle',
    defaultMessage: 'Delete Congregation?',
  },
  deleteConfirmText: {
    id: 'app.components.CongregationDeleteButton.deleteConfirmText',
    defaultMessage: 'Deleting this Congregation will permanently remove it.',
  },
  deleteConfirmDelete: {
    id: 'app.components.CongregationDeleteButton.deleteConfirmDelete',
    defaultMessage: 'Yes, Delete Congregation',
  },
  deleteConfirmCancel: {
    id: 'app.components.CongregationDeleteButton.deleteConfirmCancel',
    defaultMessage: 'No, Keep Congregation',
  },
});
